"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
var redux_1 = require("redux");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var RailItem_1 = require("../../types/models/RailItem");
var reducers = {
    query: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_SEARCH_QUERY] = function (_, action) { return action.payload; },
        _a), ''),
    result: api_1.createApiModuleReducer({
        actionType: constants_1.SEARCH,
        onSuccess: function (draftState, action) {
            draftState.data = action.payload.search.groupResults;
        },
    }, null),
    suggestions: api_1.createApiModuleReducer({
        actionType: constants_1.SUGGESTIONS,
        onRequest: function (draftState) {
            draftState.data = [];
        },
        onSuccess: function (draftState, action) {
            draftState.data = action.payload.search.results;
        },
    }, []),
    popular: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_POPULAR,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data = RailItem_1.RailItem.createInstances((_a = action.payload) === null || _a === void 0 ? void 0 : _a.data);
        },
    }, []),
    similar: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_SIMILAR,
        onSuccess: function (draftState, action) {
            draftState.data = RailItem_1.RailItem.createInstances(action.payload);
        },
    }, []),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map